/**
 * Attribute print CSS uses to size the hero KPI row.
 * Print ignores Tailwind `md:` breakpoints, so column count cannot come from
 * `md:grid-cols-*` alone.
 */
export const HERO_KPI_COUNT_ATTR = 'data-hero-kpi-count';

/**
 * Desktop column count for visible hero KPIs (preview `md:` and print).
 * @param visibleCount Number of KPIs shown.
 * @returns 1–4 columns.
 */
export const heroKpiDesktopColumnCount = (visibleCount: number): number => {
  if (visibleCount <= 1) {
    return 1;
  }
  if (visibleCount >= 4) {
    return 4;
  }
  return visibleCount;
};

/**
 * Tailwind class names for the hero cover KPI row.
 * @param visibleCount Number of KPIs shown.
 * @returns Grid class string matching preview layout.
 */
export const heroKpiGridClassName = (visibleCount: number): string => {
  const base =
    'hero-kpi-grid mt-6 grid gap-y-6 md:gap-y-0 divide-y md:divide-y-0 md:divide-x divide-white/10 max-w-5xl mx-auto';
  const columns = heroKpiDesktopColumnCount(visibleCount);
  if (columns <= 1) {
    return `${base} grid-cols-1`;
  }
  if (columns === 2) {
    return `${base} grid-cols-2`;
  }
  if (columns === 3) {
    return `${base} grid-cols-2 md:grid-cols-3`;
  }
  return `${base} grid-cols-2 md:grid-cols-4`;
};
